import { Trans, useTranslation } from 'next-i18next'

import LandingCtaButton from './LandingCtaButton'

export default function HeroCopy(): React.ReactElement {
  const { t } = useTranslation('abTestLanding')
  const headlineAccent = t('v4.hero.headlineControlAccent')

  return (
    <div className="flex flex-col gap-5 md:gap-8">
      <h1>
        <span className="block font-black uppercase leading-none text-black-rich text-h3 md:text-h2">
          <Trans components={{ br: <br /> }} i18nKey="v4.hero.headlineControl" t={t} />
        </span>
        {headlineAccent && (
          <span className="mt-1 block max-w-xl font-hand lowercase text-purple text-10 md:text-17.5 leading-12 tracking-wide md:tracking-wider">
            <Trans
              components={{ br: <br className="hidden md:block" /> }}
              i18nKey="v4.hero.headlineControlAccent"
              t={t}
            />
          </span>
        )}
      </h1>
      <div className="flex flex-col gap-8 md:gap-10">
        <p className="max-w-120 text-md leading-relaxed text-purple-deep-violet md:text-lg">
          <Trans components={{ br: <br /> }} i18nKey="v4.hero.subtextControl" t={t} />
        </p>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
          <LandingCtaButton analyticsLabel="landing_v4_hero_cta" className="w-full text-center sm:w-auto" uppercase>
            {t('v4.hero.ctaLabel')}
          </LandingCtaButton>
        </div>
      </div>
    </div>
  )
}
